import React from 'react';
import RecentlyAdded from '../../products/ProductList/RecentlyAdded/RecentlyAdded';

export default () => (
  <div className="container--outer" key="recently-added-section">
    <div className="next-section">
      <RecentlyAdded />
    </div>
  </div>
);
